import React from 'react';
import { i18n } from 'config/locales';

import Field from 'components/Form/Field';
import ValidationElement from 'components/Form/ValidationElement';
import BranchCollection from 'components/Form/BranchCollection';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { coOwnersAddressNameFields } from 'constants/enums/people';
import ErrorMessage from 'components/ErrorMessage';
import { isPVQForm } from 'helpers/form';
import CoOwner from './CoOwner';


export default class CoOwners extends ValidationElement {
  constructor(props) {
    super(props);

    this.update = this.update.bind(this);
    this.updateList = this.updateList.bind(this);
  }

  update(queue) {
    this.props.onUpdate({
      List: this.props.List,
      ...queue,
    });
  }

  updateList(values) {
    this.update({
      List: values,
    });
  }

  render() {
    const { prefix, peopleWhoKnowYou, List } = this.props;
    const attribute = `${this.props.attribute}.List`;

    const duplicatePeopleWhoKnowYou = getDuplicateNamesAndAddresses(List?.items, peopleWhoKnowYou, coOwnersAddressNameFields);

    const duplicatePeopleWhoKnowYouError = (
      <Field
        className="no-margin-bottom"
        title={i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouError.title')}
        scrollIntoView={this.props.scrollIntoView}
        hideTitle
      >
        <ErrorMessage
          title={i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouError.title')}
          message={[
            i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouError.message'),
            ...duplicatePeopleWhoKnowYou.errors.map((item) => ` - ${item}`)
          ]}
        />
      </Field>
    );

    const duplicatePeopleWhoKnowYouWarning = (
      <ErrorMessage
        isWarning
        title={i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouWarning.title')}
        message={[
          i18n.t('relationships.people.error.duplicatePeopleWhoKnowYouWarning.message'),
          ...duplicatePeopleWhoKnowYou.warnings.map((item) => ` - ${item}`)
        ]}
      />
    );

    const isPVQ = isPVQForm(this.props.formType);

    return isPVQ ? (

      <div className="co-owners">
        <BranchCollection
          label={i18n.t(`foreign.pvq.activities.direct.heading.cotitle`)}
          appendLabel={i18n.t(`foreign.pvq.activities.direct.heading.additional`)}
          {...this.props.List}
          onError={this.props.onError}
          required={this.props.required}
          onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute={attribute}
          hideInitialBranchQuestionAssumeYes

        >
          <CoOwner
            name="Item"
            bind
            prefix={`${this.props.prefix}.coOwner`}
            addressBooks={this.props.addressBooks}
            dispatch={this.props.dispatch}
            onError={this.props.onError}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute={attribute}
            formType={this.props.formType}
          />
        </BranchCollection>
        {
          (duplicatePeopleWhoKnowYou.errors.length > 0 && duplicatePeopleWhoKnowYouError)
          || (duplicatePeopleWhoKnowYou.warnings.length > 0 && duplicatePeopleWhoKnowYouWarning)
        }
      </div>
    ):(

      <div className="co-owners">
        <BranchCollection
          label={i18n.t(`foreign.${prefix}.coOwners.heading.hasCoOwners`)}
          appendLabel={i18n.t(`foreign.${prefix}.coOwners.heading.hasCoOwnersAppend`)}
          {...this.props.List}
          onError={this.props.onError}
          required={this.props.required}
          onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute={attribute}
        >
          <CoOwner
            name="Item"
            bind
            prefix={`${this.props.prefix}.coOwner`}
            addressBooks={this.props.addressBooks}
            dispatch={this.props.dispatch}
            onError={this.props.onError}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute={attribute}
          />
        </BranchCollection>
        {
          (duplicatePeopleWhoKnowYou.errors.length > 0 && duplicatePeopleWhoKnowYouError)
          || (duplicatePeopleWhoKnowYou.warnings.length > 0 && duplicatePeopleWhoKnowYouWarning)
        }
      </div>
    );
  }
}

CoOwners.defaultProps = {
  addressBooks: {},
  dispatch: (action) => { },
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};
